import {
  Autocomplete,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
//import { Autocomplete, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { MuiTelInput } from 'mui-tel-input';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import ClientAutocomplete from '../../Utils/ClientAutocomplete';
import SiteAutocomplete from '../../Utils/SiteAutocomplete';
import { getToast } from '../../../utils/toastConfig';

function ModalCC(props) {
  const {
    phoneCountryStr,
    contactContactPosition,
    contactTypeString,
    clientMCCPasswordString,
    clientMCCRPasswordString,
    clientMCCNameString,
    clientMCCLastNameString,
    contactEmailString,
    contactPhoneString,
    notesString,
    jobString,
  } = useTranslationHook();

  const weakPWErrorAlert = (missingRequirements) => {
    toast.dismiss();
    if (missingRequirements.length > 0) {
      toast.error(
        'La contraseña ingresada es débil. No cumple con los siguientes requisitos:',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );

      missingRequirements.forEach((requirement) => {
        toast.info(`${requirement}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [client, setClient] = useState(null);
  const [site, setSite] = useState([]);
  const [isContactOfSite, setIsContactOfSite] = useState(false);
  const [haveAccess, setHaveAccess] = useState(false);
  const [password, setPW] = useState('');
  const [verifyPassword, setVPW] = useState('');
  const [contactTypeId, setContactTypeId] = useState('');
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('MX');
  const [notes, setNotes] = useState('');
  const [job, setJob] = useState('');

  const handleEntering = () => {
    setEmail('');
    setName('');
    setLastName('');
    setClient(null);
    setSite(null);
    setHaveAccess(false);
    setIsContactOfSite(false);
    setPW('');
    setVPW('');
    setContactTypeId('');
    setPhone('');
    setCountryCode('MX');
    setNotes('');
    setJob('');
  };

  function hide() {
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Contacto creado exitosamente en la base de datos.',
    });
    let endpoint = `${GlobalVariables.getURL()}listClientsContacts`;
    if (props.selectedClients.length > 0) {
      endpoint += `?id=${props.selectedClients}`;
    }
    props.getContacts(endpoint);
  }

  function createContact(event) {
    event.preventDefault();
    if (password === verifyPassword) {
      const requestData = {
        client_id: client,
        isSiteContact: isContactOfSite,
        site_ids: site,
        name: name,
        last_names: lastName,
        email: email,
        telefono: phone,
        countryCode: countryCode,
        contact_type_id: contactTypeId,
        notes,
        job,
      };

      if (password !== '') {
        requestData.password = password;
      }

      customAxios
        .post(`${GlobalVariables.getURL()}createContact`, requestData, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then(
          (response) => {
            hide();
          },
          (error) => {
            if (error.response.data.message.startsWith('Week password')) {
              const errorMessage = error.response.data.message;
              const errorParts = errorMessage.split(':');
              const errors = errorParts[1].trim().split('. ');

              weakPWErrorAlert(errors);
            } else if (error.response.data.message === 'User already exists') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe un usuario con esta información. Vuelve a intentarlo.',
              });
            } else {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Error al crear contacto. Vuelve a intentarlo.',
              });
            }
          }
        );
    } else {
      toast.dismiss();
      getToast({
        status: 'error',
        title: 'Contraseñas no coinciden. Vuelve a intentarlo.',
      });
    }
  }

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
      onEntering={handleEntering}
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Nuevo contacto
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='cc-form' onSubmit={createContact}>
          <div className='row'>
            <div className='col-md-9'>
              <ClientAutocomplete setClient={setClient} />
            </div>
            <div className='col-md-3'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isContactOfSite}
                    onChange={() => setIsContactOfSite(!isContactOfSite)}
                  />
                }
                label='¿Es el contacto de una sucursal?'
              />
            </div>
          </div>

          {isContactOfSite && (
            <>
              <br />

              <div className='row'>
                <div className='col-md-12'>
                  <SiteAutocomplete
                    clientId={client}
                    setSite={setSite}
                    siteIds={site}
                  />
                </div>
              </div>
            </>
          )}

          <br />
          <Divider>Información del contacto</Divider>
          <br />

          <div className='row'>
            <div className='col-md-6'>
              <TextField
                sx={{ width: '100%' }}
                label={contactEmailString}
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className='col-md-6'>
              <MuiTelInput
                sx={{ width: '100%' }}
                label={contactPhoneString}
                defaultCountry={countryCode}
                langOfCountryName={phoneCountryStr}
                value={phone}
                onChange={(newPhone, info) => {
                  setPhone(newPhone);
                  setCountryCode(info.countryCode);
                }}
                forceCallingCode
                disableFormatting
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={jobString}
                type='text'
                value={job}
                onChange={(e) => setJob(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-6'>
              <TextField
                sx={{ width: '100%' }}
                label={clientMCCNameString}
                type='text'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className='col-md-6'>
              <TextField
                sx={{ width: '100%' }}
                label={clientMCCLastNameString}
                type='text'
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-9'>
              <FormControl variant='outlined' sx={{ width: '100%' }}>
                <InputLabel id='select-outlined-label'>
                  Tipo de contacto
                </InputLabel>
                <Select
                  labelId='select-outlined-label'
                  label='Tipo de contacto'
                  type='text'
                  value={contactTypeId}
                  onChange={(e) => setContactTypeId(e.target.value)}
                >
                  <MenuItem value={1}>Principal</MenuItem>
                  <MenuItem value={2}>Secundario</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className='col-md-3'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={haveAccess}
                    onChange={() => {
                      setHaveAccess(!haveAccess);
                      setPW('');
                      setVPW('');
                    }}
                  />
                }
                label='¿Tendrá acceso?'
              />
            </div>
          </div>

          <br />

          {haveAccess && (
            <>
              <div className='row'>
                <div className='col-md-6'>
                  <Tooltip
                    title='Mínimo 9 caracteres (una mayúscula, un número y un caracter especial).'
                    arrow
                  >
                    <TextField
                      sx={{ width: '100%' }}
                      label='Contraseña'
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => setPW(e.target.value)}
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton
                              onClick={handleClickShowPassword}
                              edge='end'
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOffOutlinedIcon />
                              ) : (
                                <VisibilityOutlinedIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Tooltip>
                </div>
                <div className='col-md-6'>
                  <Tooltip
                    title='Mínimo 9 caracteres (una mayúscula, un número y un caracter especial).'
                    arrow
                  >
                    <TextField
                      sx={{ width: '100%' }}
                      label='Repetir contraseña'
                      type={showPassword ? 'text' : 'password'}
                      value={verifyPassword}
                      onChange={(e) => setVPW(e.target.value)}
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton
                              onClick={handleClickShowPassword}
                              edge='end'
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOffOutlinedIcon />
                              ) : (
                                <VisibilityOutlinedIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Tooltip>
                </div>
              </div>

              <br />
            </>
          )}

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type={'text'}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type='submit' form='cc-form' className='save-modal-button'>
          Guardar
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCC;
